import { Button, Divider, Empty, List, Space, Tag, Typography } from 'antd';
import { FC, ReactNode, memo } from 'react';
import { Link45deg, Toggles } from 'react-bootstrap-icons';

import { ReferralLinksLimit } from '@/modules/Sites';

interface Props<T> {
  dataSource: T[];
  disabled?: boolean;
  isButtonActive?: boolean;
  isEditingList?: boolean;
  onButtonClick?: () => void;
  renderItem?: (list: T, index: number) => ReactNode;
}

function ReferralLinksList<T>({
  dataSource,
  disabled,
  isButtonActive,
  isEditingList = false,
  onButtonClick,
  renderItem,
}: Props<T>): ReturnType<FC<Props<T>>> {
  return (
    <>
      <List
        className="app-list"
        dataSource={ dataSource }
        locale={{
          emptyText: <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description="Немає посилань"/>
        }}
        header={
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky'
            }}
          >
            <Typography.Text strong>
              Реферальні посилання
              &nbsp;
              <Tag color="blue">{ dataSource.length } { isEditingList ? `/ ${ ReferralLinksLimit }` : '' }</Tag>
            </Typography.Text>
            <Space size="small">
              <Button
                icon={ <Toggles/> }
                type={ isButtonActive ? 'primary' : 'default' }
                disabled={ disabled }
                size="small"
                onClick={ onButtonClick }
              />
              <Divider type="vertical"/>
              { <Link45deg size={ 22 }/> }
            </Space>
          </div>
        }
        renderItem={ renderItem ? (item, index) => renderItem(item, index) : undefined }
      />
    </>
  );
};

const m: <T>(component: T) => T = memo;

export const ReferralLinksListComponent = m(ReferralLinksList);
